import React from "react";
import { useLang } from "../context/LanguageContext";

// Robiquity-style large scrolling keyword band — bold, alternating filled/outlined words.
export default function KeywordMarquee() {
  const { t } = useLang();
  const words = t.marqueeWords || [];
  const row = [...words, ...words, ...words];

  return (
    <section className="py-16 md:py-24 overflow-hidden border-y border-[rgba(10,31,60,0.08)] bg-[#e7f1ea]">
      <div className="flex w-max rq-marquee items-center">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className="font-display font-bold text-5xl md:text-7xl lg:text-8xl leading-none px-6"
              style={
                i % 2 === 0
                  ? { color: "var(--rq-navy)" }
                  : { color: "var(--rq-green)" }
              }
            >
              {w}
            </span>
            <span className="mx-2 h-3 w-3 rounded-full bg-[color:var(--rq-green)] shrink-0" />
          </span>
        ))}
      </div>
    </section>
  );
}
